import "dayjs/locale/he";

import "./styles/global.scss";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TXLogger } from "@tx/framework";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { Provider } from "mobx-react";
import { SnackbarProvider } from "notistack";
import { createRoot } from "react-dom/client";

import { App } from "./components";
import { rootContext } from "./context/RootContext";
import { IsStoreOpen } from "./helpers/opening-hours";

// Set Hebrew locale with Sunday as first day of week and day names with geresh
dayjs.extend(updateLocale);
dayjs.updateLocale("he", {
	weekStart: 0, // Sunday
	weekdaysMin: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
});

// import reportWebVitals from "./reportWebVitals";
TXLogger.getInstance("ipad-app-client");
// @ts-ignore
window.rootContext = rootContext;
// @ts-ignore
window.IsStoreOpen = IsStoreOpen;

const rootNode = document.getElementById("root");
const reactRoot = createRoot(rootNode!);
reactRoot.render(
	<Provider rootContext={rootContext}>
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
			<App />
			<SnackbarProvider maxSnack={1} />
		</LocalizationProvider>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
